<template>
	<el-dialog
		:title="title"
		:visible.sync="showerrorwin"
		width="30%"
		:append-to-body="true"
		lock-scroll
		:show-close="false"
		:close-on-click-modal="false"
	>
		<div class="errorwin">
			<div class="errormsg">
				<span>{{ errormsg }}</span>
			</div>
		</div>
		<el-row>
			<el-col :span="8" style="color:transparent">1</el-col>
			<el-col :span="12">
				<el-button type="success" @click="dialogsrue">{{btnsure}}</el-button>
				<el-button @click="dialogclose" style="margin-left:10px">{{btncancel}}</el-button>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';	
export default {
	components: {},
	data() {
		return {
			showerrorwin: false,
			isread:true,
			errormsg: '',
			errorcode: '',
			focuscontrol:'',
			title:'',
			btnsure:'',
			btncancel:''
		};
	},
	methods: {
		init(param) {
			this.title=this.$lang.label.public.wintitletips;
			this.btnsure=this.$lang.label.public.sure;
			this.btncancel=this.$lang.label.public.cancel;
			
			var that=this;
			this.errorcode='';
			this.showerrorwin = true;
			if(param.isread!=undefined)
				this.isread=param.isread;
			this.errormsg = param.errormsg;
			if(param.focuscontrol!=undefined)
				this.focuscontrol=param.focuscontrol;
			if(this.isread)
				this.$tool.ReadMsg(this.errormsg);
		},
		dialogsrue(){
			this.showerrorwin=false;
			this.$emit('errorwincallback', {
				type:'sure',
				focuscontrol:this.focuscontrol
			});
		},
		dialogclose(){
			//debugger
			this.showerrorwin=false;
			this.$emit('errorwincallback', {
				type:'cancel',
				focuscontrol:this.focuscontrol
			});
		}
	}
};
</script>

<style></style>
